// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"b5253c46","726":"cc69ac21"}[chunkId] + ".chunk.js";
};